import { Navigate, Outlet } from 'react-router-dom'

import { useAuthStore } from '@/stores/auth'

import { paths } from '@/config/paths'

import type { UserRole } from '@/types/user-role'

interface RoleProtectedRouteProps {
  requiredRoles?: UserRole[]
  requiredPermissions?: string[]
}

export default function RoleProtectedRoute({ requiredRoles = [], requiredPermissions = [] }: RoleProtectedRouteProps) {
  const user = useAuthStore((state) => state.user)

  if (!user) return <Navigate to={paths.public.auth.login.getHref()} replace />

  // role check
  const hasRole = requiredRoles.length === 0 || requiredRoles.some((role) => user.roles.includes(role))

  // permission check
  const hasPermission =
    requiredPermissions.length === 0 || requiredPermissions.some((perm) => user.permissions?.includes(perm))

  if (!hasRole || !hasPermission) {
    return <Navigate to={paths.public.unauthorized.getHref()} replace />
  }

  return <Outlet />
}
